import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[sukaStackItem]'
})
export class StackItem {
  @Input('sukaStackItem') type: 'default' | 'fill' = 'default';

  @HostBinding('class.stack__item') baseClass = true;
  @HostBinding('class.stack__item--fill') @Input() fill = false;
}
